export default __webpack_public_path__ + "static/media/464.28c18a0c.png";